<template>
  <page-block full-page>
    <page-content-placeholder :img-src="NoRoleImage" text="Доступ закрыт" max-width="640px">
      <div class="paragraph-m mt-1">
        Вам не назначена роль доступа к пространству. Обратитесь к администратору своего пространства, если вам
        необходим доступ.
      </div>
    </page-content-placeholder>
  </page-block>
</template>

<script setup lang="ts">
import NoRoleImage from '@/assets/img/layouts/no-role.svg';
import PageContentPlaceholder from '@/core/components/common/PageContentPlaceholder.vue';
import PageBlock from '@/core/components/interface/PageBlock.vue';
</script>
